/**
 * Case combobox for the Impower document editor (GeneralDocumentData section).
 * Mirrors client_injects/src/features/caseComboBox.js; persistence uses document-specific
 * API routes (wired when the backend is ready).
 */

const parseDocumentHrIdFromLocation = () => {
  const parts = window.location.pathname.split('/').filter(Boolean)
  const editAt = parts.indexOf('edit')
  if (editAt !== -1 && parts[editAt + 1]) {
    return parts[editAt + 1]
  }
  if (editAt > 0) {
    return parts[editAt - 1]
  }
  return parts[parts.length - 1] || ''
}

const LUX_DOCUMENT_EDITOR_SPIN_STYLE_ID = 'lux-document-editor-combobox-spin-keyframes'

/** Ensures @keyframes exist once in document.head (safe if this feature is injected multiple times). */
const ensureDocumentEditorComboSpinKeyframes = () => {
  if (document.getElementById(LUX_DOCUMENT_EDITOR_SPIN_STYLE_ID)) return
  const style = document.createElement('style')
  style.id = LUX_DOCUMENT_EDITOR_SPIN_STYLE_ID
  style.textContent = `
    @keyframes luxDocumentEditorSpin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `
  document.head.appendChild(style)
}

const documentEditorCaseComboBox = () => {
  const generalBlock = document.querySelector('#GeneralDocumentData')
  if (!generalBlock) return

  let section = document.querySelector(
    '#GeneralDocumentData .section-content > .ant-row'
  )
  if (!section) return
  if (section.querySelector('#luxDocumentCaseComboBox')) return

  ensureDocumentEditorComboSpinKeyframes()

  const currentDocumentId = parseDocumentHrIdFromLocation()

  let committedCaseId = null
  let dbAssociationId = null
  /** Mirrors `Documents.isShared` when this document is linked to a case. */
  let documentIsShared = true
  let dataLoaded = false
  let luxDocumentCaseComboEditMode = false

  const wrapper = document.createElement('div')
  wrapper.id = 'luxDocumentCaseComboBox'
  wrapper.className = 'ant-row ant-form-item'
  wrapper.style.marginBottom = '0'
  wrapper.style.padding = '0 16px'

  const label = document.createElement('div')
  label.className = 'ant-col ant-form-item-label'
  label.textContent = 'Vorgang'

  const content = document.createElement('div')
  content.className = 'ant-col ant-col-24 ant-form-item-control'
  content.style.width = '100%'
  content.style.display = 'block'

  const root = document.createElement('div')
  root.style.position = 'relative'
  root.style.width = '100%'

  const display = document.createElement('input')
  display.type = 'text'
  display.className = 'ant-input'
  display.placeholder = 'Bitte auswählen oder eintippen...'
  display.style.width = '100%'
  display.style.borderRadius = '4px'
  display.style.padding = '6px 40px 6px 16px'
  display.style.fontSize = '1.6rem'
  display.style.cursor = 'pointer'
  display.style.boxShadow = 'none'

  content.addEventListener('mouseover', () => {
    if (!luxDocumentCaseComboEditMode) return
    display.style.boxShadow = '0 0 0 2px black'
    display.style.border = 'none'
    display.style.outline = 'none'
  })
  content.addEventListener('mouseout', () => {
    if (!luxDocumentCaseComboEditMode) return
    display.style.boxShadow = '0 0 0 1px #d9d9d9'
  })

  const deleteButton = document.createElement('button')
  deleteButton.innerHTML = '×'
  deleteButton.type = 'button'
  deleteButton.style.position = 'absolute'
  deleteButton.style.right = '8px'
  deleteButton.style.top = '50%'
  deleteButton.style.transform = 'translateY(-50%)'
  deleteButton.style.background = 'transparent'
  deleteButton.style.border = 'none'
  deleteButton.style.cursor = 'pointer'
  deleteButton.style.fontSize = '24px'
  deleteButton.style.color = '#999'
  deleteButton.style.width = '24px'
  deleteButton.style.height = '24px'
  deleteButton.style.display = 'none'
  deleteButton.style.lineHeight = '1'
  deleteButton.style.padding = '0'
  deleteButton.style.borderRadius = '2px'
  deleteButton.style.transition = 'color 0.2s'

  deleteButton.addEventListener('mouseover', () => {
    deleteButton.style.color = '#ff4d4f'
    deleteButton.style.background = '#fff2f0'
  })
  deleteButton.addEventListener('mouseout', () => {
    deleteButton.style.color = '#999'
    deleteButton.style.background = 'transparent'
  })

  deleteButton.addEventListener('click', async (e) => {
    e.stopPropagation()
    if (!luxDocumentCaseComboEditMode || !dataLoaded) return
    const prevCaseId = selectedCaseId
    const prevDisplay = originalDisplayValue
    selectedCaseId = null
    display.value = ''
    deleteButton.style.display = 'none'
    display.style.color = '#000'
    display.style.boxShadow = '0 0 0 1px #d9d9d9'
    const ok = await persistCaseAssociationFromCombo()
    if (!ok) {
      selectedCaseId = prevCaseId
      display.value = prevDisplay
      originalDisplayValue = prevDisplay
      if (prevCaseId !== null) {
        deleteButton.style.display = 'block'
      }
    }
  })

  const drop = document.createElement('div')
  drop.style.position = 'absolute'
  drop.style.left = '0'
  drop.style.width = '100%'
  drop.style.maxHeight = '280px'
  drop.style.overflowY = 'auto'
  drop.style.background = '#fff'
  drop.style.border = '1px solid #d9d9d9'
  drop.style.borderRadius = '4px'
  drop.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'
  drop.style.display = 'none'
  drop.style.zIndex = '9999'
  drop.style.marginTop = '4px'

  const opts = document.createElement('div')

  const spinner = document.createElement('div')
  spinner.style.display = 'none'
  spinner.style.padding = '12px'
  spinner.style.textAlign = 'center'
  spinner.innerHTML = `
      <div style="
        border: 2px solid #f3f3f3;
        border-top: 2px solid #1890ff;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: luxDocumentEditorSpin 1s linear infinite;
        margin: 0 auto;
      "></div>
    `

  drop.appendChild(spinner)
  drop.appendChild(opts)

  const sharedRow = document.createElement('div')
  sharedRow.id = 'luxDocumentCaseSharedRow'
  sharedRow.style.display = 'none'
  sharedRow.style.marginTop = '28px'
  sharedRow.style.flexDirection = 'row'
  sharedRow.style.alignItems = 'center'
  sharedRow.style.gap = '10px'
  sharedRow.style.flexWrap = 'wrap'

  const sharedLabel = document.createElement('span')
  sharedLabel.textContent = 'Mit Kunden geteilt'
  sharedLabel.style.fontSize = '1.6rem'
  sharedLabel.style.fontWeight = '500'
  sharedLabel.style.marginRight = '12px'
  sharedLabel.style.color = 'rgba(0,0,0,0.85)'

  const sharedSwitch = document.createElement('button')
  sharedSwitch.type = 'button'
  sharedSwitch.setAttribute('role', 'switch')
  sharedSwitch.setAttribute('aria-label', 'Mit Kunden geteilt')
  sharedSwitch.style.position = 'relative'
  sharedSwitch.style.width = '44px'
  sharedSwitch.style.height = '22px'
  sharedSwitch.style.border = 'none'
  sharedSwitch.style.borderRadius = '100px'
  sharedSwitch.style.cursor = 'pointer'
  sharedSwitch.style.padding = '0'
  sharedSwitch.style.flexShrink = '0'
  sharedSwitch.style.transition = 'background 0.2s'

  const sharedThumb = document.createElement('span')
  sharedThumb.style.position = 'absolute'
  sharedThumb.style.top = '2px'
  sharedThumb.style.left = '2px'
  sharedThumb.style.width = '18px'
  sharedThumb.style.height = '18px'
  sharedThumb.style.borderRadius = '50%'
  sharedThumb.style.background = '#fff'
  sharedThumb.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)'
  sharedThumb.style.transition = 'left 0.2s'
  sharedSwitch.appendChild(sharedThumb)

  sharedRow.appendChild(sharedLabel)
  sharedRow.appendChild(sharedSwitch)

  let LIST = []
  const serviceProvidersList = new Map()
  let selectedServiceProviderId = null
  let selectedPropertyId = null
  let selectedCaseId = null
  let originalDisplayValue = ''

  const authHeader = () => {
    try {
      return JSON.parse(localStorage.auth).token
    } catch (_) {
      return null
    }
  }

  /** First Impower document title field (excludes Lux-injected controls). */
  function findDocumentTitleInput() {
    const rootEl = document.querySelector('#GeneralDocumentData')
    if (!rootEl) return null
    for (const input of rootEl.querySelectorAll('.TextInput input.ant-input')) {
      if (wrapper.contains(input)) continue
      return input
    }
    return null
  }

  /** Last known title from live `input` events (React may lag behind until blur). */
  let cachedImpDocumentTitle = ''
  /** Title last written to the linked case, so a plain Speichern does not rewrite it. */
  let lastSyncedDocumentTitle = ''
  let userEditedDocumentTitle = false

  function readLiveDocumentTitle() {
    const el = findDocumentTitleInput()
    if (el && typeof el.value === 'string') {
      cachedImpDocumentTitle = el.value.trim()
      return cachedImpDocumentTitle
    }
    return cachedImpDocumentTitle
  }

  /** Blur focused title field so React/Ant commit DOM, then read fresh value on next frame. */
  function flushActiveDocumentTitleInput() {
    return new Promise((resolve) => {
      const el = findDocumentTitleInput()
      if (!el) {
        readLiveDocumentTitle()
        resolve()
        return
      }
      const finish = () => {
        readLiveDocumentTitle()
        resolve()
      }
      if (document.activeElement === el) {
        el.blur()
        requestAnimationFrame(() => {
          requestAnimationFrame(finish)
        })
      } else {
        finish()
      }
    })
  }

  generalBlock.addEventListener(
    'input',
    (e) => {
      const titleEl = findDocumentTitleInput()
      if (titleEl && e.target === titleEl && typeof titleEl.value === 'string') {
        cachedImpDocumentTitle = titleEl.value.trim()
        userEditedDocumentTitle = true
      }
    },
    true
  )
  generalBlock.addEventListener(
    'change',
    (e) => {
      const titleEl = findDocumentTitleInput()
      if (titleEl && e.target === titleEl && typeof titleEl.value === 'string') {
        cachedImpDocumentTitle = titleEl.value.trim()
        userEditedDocumentTitle = true
      }
    },
    true
  )

  function noteDocumentTitleBaseline() {
    if (userEditedDocumentTitle || lastSyncedDocumentTitle) return
    const title = readLiveDocumentTitle()
    if (title) lastSyncedDocumentTitle = title
  }

  function buildAssociateDocumentPostBody(overrides = {}) {
    const title = readLiveDocumentTitle()
    return {
      caseId: selectedCaseId,
      documentHrId: currentDocumentId,
      isShared: documentIsShared,
      ...(title ? { name: title } : {}),
      ...overrides,
    }
  }

  function updateSharedSwitchVisual() {
    const on = documentIsShared
    sharedSwitch.setAttribute('aria-checked', on ? 'true' : 'false')
    sharedSwitch.style.background = on ? '#1890ff' : 'rgba(0,0,0,0.25)'
    sharedThumb.style.left = on ? '24px' : '2px'
  }

  function refreshSharedRowVisibility() {
    sharedRow.style.display = dbAssociationId != null ? 'flex' : 'none'
    if (dbAssociationId != null) {
      updateSharedSwitchVisual()
    }
  }

  async function persistDocumentIsShared(nextVal) {
    if (dbAssociationId == null || selectedCaseId == null) return
    const prev = documentIsShared
    documentIsShared = nextVal
    updateSharedSwitchVisual()
    const token = authHeader()
    if (!token) {
      documentIsShared = prev
      updateSharedSwitchVisual()
      return
    }
    try {
      await flushActiveDocumentTitleInput()
      const response = await fetch(`${baseApiUrl}/api/cases/associate-document-to-case`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(
          buildAssociateDocumentPostBody({
            isShared: nextVal,
          })
        ),
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok) {
        console.error('[luxDocumentCaseComboBox] POST isShared failed:', data.error)
        documentIsShared = prev
        updateSharedSwitchVisual()
        return
      }
      if (typeof data.association?.isShared === 'boolean') {
        documentIsShared = data.association.isShared
        updateSharedSwitchVisual()
      }
    } catch (error) {
      console.error('[luxDocumentCaseComboBox] persistDocumentIsShared:', error)
      documentIsShared = prev
      updateSharedSwitchVisual()
    }
  }

  sharedSwitch.addEventListener('click', (e) => {
    e.stopPropagation()
    if (!luxDocumentCaseComboEditMode || sharedSwitch.disabled) return
    void persistDocumentIsShared(!documentIsShared)
  })

  const DOCUMENT_HEADER_SAVE_LABELS = [
    'speichern',
    'save',
    'save all',
    'save and continue',
    'speichern und weiter',
    'als entwurf speichern',
    'bereit zur verbuchung',
    'ready for invoice',
  ]
  const DOCUMENT_HEADER_EDIT_LABELS = ['bearbeiten', 'edit']

  function getDocumentEditorVisibleHeaderButtonTexts() {
    const pageHeader =
      document.querySelector('.DocumentEditor.page .PageHeader') ||
      document.querySelector('.overlay-page .DocumentEditor .PageHeader') ||
      document.querySelector('.DocumentEditor .PageHeader')
    const area = pageHeader?.querySelector('.right-side') || pageHeader
    if (!area) return []
    return Array.from(area.querySelectorAll('button'))
      .filter((btn) => btn.offsetParent !== null && !btn.disabled)
      .map((btn) =>
        (btn.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase()
      )
  }

  /**
   * True when Impower already shows edit mode (e.g. save in header after upload opens editor),
   * false when only "Bearbeiten" is offered. Mirrors onPropertyPageMatch detectDomEditMode.
   */
  function detectDocumentEditorImpowerEditMode() {
    const texts = getDocumentEditorVisibleHeaderButtonTexts()
    if (DOCUMENT_HEADER_SAVE_LABELS.some((l) => texts.includes(l))) {
      return true
    }
    if (DOCUMENT_HEADER_EDIT_LABELS.some((l) => texts.includes(l))) {
      return false
    }
    const general = document.querySelector('#GeneralDocumentData')
    if (!general) return false
    const hasEditableField = general.querySelector(
      'input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), .ant-select:not(.ant-select-disabled) .ant-select-selector'
    )
    return !!hasEditableField
  }

  function syncComboReadOnlyWithImpowerDocumentEditMode() {
    if (!dataLoaded) return
    if (Date.now() < luxCaseComboForceReadOnlyUntil) {
      setDocumentCaseComboReadOnly(true)
      return
    }
    const impowerEdit = detectDocumentEditorImpowerEditMode()
    setDocumentCaseComboReadOnly(!impowerEdit)
  }

  let documentEditorEditSyncObserver = null
  let documentEditorEditSyncDebounce = null
  /** After our Speichern handler runs, ignore sync briefly so Impower header still showing "Speichern" does not re-enable the combo. */
  let luxCaseComboForceReadOnlyUntil = 0

  function setupDocumentEditorImpowerEditModeSync() {
    syncComboReadOnlyWithImpowerDocumentEditMode()
    ;[100, 300, 600, 1200, 2500].forEach((ms) => {
      setTimeout(() => syncComboReadOnlyWithImpowerDocumentEditMode(), ms)
    })

    if (documentEditorEditSyncObserver) {
      documentEditorEditSyncObserver.disconnect()
    }
    documentEditorEditSyncObserver = new MutationObserver(() => {
      clearTimeout(documentEditorEditSyncDebounce)
      documentEditorEditSyncDebounce = setTimeout(
        () => syncComboReadOnlyWithImpowerDocumentEditMode(),
        120
      )
    })
    documentEditorEditSyncObserver.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  function setDocumentCaseComboReadOnly(readOnly) {
    luxDocumentCaseComboEditMode = !readOnly
    display.disabled = readOnly
    display.style.cursor = readOnly ? 'not-allowed' : 'pointer'
    display.style.opacity = readOnly ? '0.72' : '1'
    wrapper.style.pointerEvents = readOnly ? 'none' : 'auto'
    deleteButton.style.pointerEvents = readOnly ? 'none' : 'auto'
    deleteButton.disabled = readOnly
    sharedSwitch.disabled = readOnly
    sharedSwitch.style.cursor = readOnly ? 'not-allowed' : 'pointer'
    sharedSwitch.style.opacity = readOnly ? '0.85' : '1'
    if (readOnly) {
      drop.style.display = 'none'
      deleteButton.style.display = 'none'
    } else if (selectedCaseId !== null) {
      deleteButton.style.display = 'block'
    }
  }

  async function flushCaseAssociationToServer() {
    const token = authHeader()
    if (!token) return false

    const dirty = committedCaseId !== selectedCaseId
    if (!dirty) return true

    wrapper.style.cursor = 'not-allowed'
    wrapper.style.opacity = '0.5'
    wrapper.style.pointerEvents = 'none'

    try {
      if (selectedCaseId == null && dbAssociationId != null) {
        const response = await fetch(
          `${baseApiUrl}/api/cases/associate-document-to-case?caseDocumentId=${dbAssociationId}`,
          {
            method: 'DELETE',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )
        const data = await response.json().catch(() => ({}))
        if (!response.ok) {
          console.error('Error deleting case-document association:', data.error)
          return false
        }
        committedCaseId = null
        dbAssociationId = null
        refreshSharedRowVisibility()
        return true
      }

      if (selectedCaseId != null) {
        await flushActiveDocumentTitleInput()
        const response = await fetch(`${baseApiUrl}/api/cases/associate-document-to-case`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(buildAssociateDocumentPostBody()),
        })
        const data = await response.json().catch(() => ({}))
        if (!response.ok) {
          console.error('Error saving case-document association:', data.error)
          return false
        }
        if (data.association && data.association.id) {
          dbAssociationId = data.association.id
        }
        committedCaseId = selectedCaseId
        if (typeof data.association?.isShared === 'boolean') {
          documentIsShared = data.association.isShared
        } else {
          documentIsShared = true
        }
        const syncedTitle = readLiveDocumentTitle()
        if (syncedTitle) lastSyncedDocumentTitle = syncedTitle
        refreshSharedRowVisibility()
        return true
      }

      return true
    } catch (error) {
      console.error('flushCaseAssociationToServer:', error)
      return false
    } finally {
      wrapper.style.cursor = 'pointer'
      wrapper.style.opacity = '1'
      if (luxDocumentCaseComboEditMode) {
        wrapper.style.pointerEvents = 'auto'
      }
    }
  }

  async function syncLinkedDocumentTitleFromEditor() {
    if (!dataLoaded || !currentDocumentId) return
    const title = readLiveDocumentTitle()
    if (!title || title === lastSyncedDocumentTitle) return
    const token = authHeader()
    if (!token) return
    try {
      // Rename only. Re-posting the association would move another case's copy
      // of this file onto the selected case.
      const response = await fetch(
        `${baseApiUrl}/api/cases/impower-documents/${encodeURIComponent(currentDocumentId)}/name`,
        {
          method: 'PATCH',
          // "Speichern und Weiter" navigates in the same click; keepalive stops the browser cancelling the rename.
          keepalive: true,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name: title }),
        }
      )
      if (response.ok) lastSyncedDocumentTitle = title
    } catch (error) {
      console.error('[luxDocumentCaseComboBox] title sync:', error)
    }
  }

  async function persistCaseAssociationFromCombo() {
    if (!dataLoaded) return true
    const ok = await flushCaseAssociationToServer()
    if (!ok) {
      display.style.boxShadow = '0 0 0 2px red'
      display.style.color = 'red'
      display.value = 'Fehler beim Speichern der Zuordnung'
      return false
    }
    if (selectedCaseId !== null) {
      const selectedCase = LIST.find((c) => c.id === selectedCaseId)
      if (selectedCase) {
        const title = `${selectedCase.companyCode}-${selectedCase.companyCaseId} ${selectedCase.title}`
        originalDisplayValue = title
        display.value = title
      }
    } else {
      originalDisplayValue = ''
      display.value = ''
    }
    display.style.color = '#000'
    display.style.boxShadow = '0 0 0 1px #d9d9d9'
    return true
  }

  function onDocumentEditorEditClick() {
    if (!dataLoaded) return
    setDocumentCaseComboReadOnly(false)
  }

  async function initCaseList() {
    spinner.style.display = 'block'
    opts.style.display = 'none'

    try {
      const token = authHeader()
      if (!token) {
        LIST = []
        return
      }

      selectedCaseId = null
      dbAssociationId = null
      committedCaseId = null
      documentIsShared = true

      const casesUrl = `${baseApiUrl}/api/cases?documentHrId=${encodeURIComponent(currentDocumentId)}`
      const response = await fetch(casesUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        console.warn(
          '[luxDocumentCaseComboBox] GET /api/cases failed:',
          response.status
        )
        LIST = []
        return
      }

      const data = await response.json()
      LIST = Array.isArray(data.cases) ? data.cases : []
      LIST.forEach((case_) => {
        if (case_.serviceProviders && typeof case_.serviceProviders === 'object') {
          Object.entries(case_.serviceProviders).forEach(([id, sp]) => {
            sp && serviceProvidersList.set(id, sp.name)
          })
        }
      })
      if (data.counterpartContactId) {
        const stringifiedId = data.counterpartContactId.toString()
        if (serviceProvidersList.has(stringifiedId)) {
          selectedServiceProviderId = stringifiedId
        }
      }
      if (data.associatedCase) {
        const associatedCase = Array.isArray(data.associatedCase)
          ? data.associatedCase[0]
          : data.associatedCase
        if (associatedCase && associatedCase.caseId) {
          selectedCaseId = associatedCase.caseId
          dbAssociationId = associatedCase.id
          documentIsShared =
            typeof associatedCase.isShared === 'boolean'
              ? associatedCase.isShared
              : true
        }
      }
      committedCaseId = selectedCaseId
      if (data.propertyId) {
        selectedPropertyId = data.propertyId
      }

      if (selectedCaseId !== null) {
        const selectedCase = LIST.find((case_) => case_.id === selectedCaseId)
        if (selectedCase) {
          const title = `${selectedCase.companyCode}-${selectedCase.companyCaseId} ${selectedCase.title}`
          display.value = title
          originalDisplayValue = title
          deleteButton.style.display = 'block'
        }
      }
    } catch (error) {
      console.error('[luxDocumentCaseComboBox] Error fetching cases:', error)
      LIST = []
    } finally {
      spinner.style.display = 'none'
      opts.style.display = 'block'
      renderOptions('')
      dataLoaded = true
      refreshSharedRowVisibility()
      noteDocumentTitleBaseline()
      ;[300, 1000, 2500].forEach((ms) => setTimeout(noteDocumentTitleBaseline, ms))
      setupDocumentEditorImpowerEditModeSync()
    }
  }

  function renderOptions(filter) {
    opts.innerHTML = ''

    const filteredCases = LIST.filter((case_) => {
      if (filter) return true
      if (selectedServiceProviderId !== null || selectedPropertyId !== null) {
        if (selectedPropertyId !== null) {
          if (case_.propertyId.toString() !== selectedPropertyId.toString()) {
            return false
          }
        }
        if (selectedServiceProviderId !== null) {
          if (!case_.serviceProviders[selectedServiceProviderId]) {
            return false
          }
        }
      }
      return true
    }).filter((case_) => {
      const title = `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`
      const SearchableTitle = `${title} ${case_.customer}`
      return SearchableTitle.toLowerCase().includes(filter.toLowerCase())
    })

    if (filter && filter.trim() !== '' && filteredCases.length === 0) {
      const noResultsMessage = document.createElement('div')
      noResultsMessage.textContent = 'Kein Vorgang gefunden'
      noResultsMessage.style.padding = '12px'
      noResultsMessage.style.textAlign = 'center'
      noResultsMessage.style.color = '#999'
      noResultsMessage.style.fontSize = '1.4rem'
      opts.appendChild(noResultsMessage)
      return
    }

    filteredCases.forEach((case_) => {
      const title = `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`
      const item = document.createElement('div')
      item.textContent = title
      item.style.padding = '6px 8px'
      item.style.cursor = 'pointer'
      item.style.fontSize = '1.4rem'
      item.style.fontWeight = 'bold'
      const subtitle = document.createElement('div')
      subtitle.textContent = 'Kunde: ' + (case_.customer || 'Nicht bekannt')
      subtitle.style.fontSize = '1.2rem'
      subtitle.style.color = ' #999'
      subtitle.style.fontWeight = 'normal'
      item.appendChild(subtitle)

      item.addEventListener('mouseover', () => {
        item.style.background = '#f5f5f5'
      })
      item.addEventListener('mouseout', () => {
        item.style.background = '#fff'
      })

      item.addEventListener('click', async () => {
        const prevCaseId = selectedCaseId
        const prevDisplay = originalDisplayValue
        display.value = title
        display.style.color = '#000'
        display.style.boxShadow = '0 0 0 1px #d9d9d9'
        selectedCaseId = case_.id
        drop.style.display = 'none'
        deleteButton.style.display = 'block'
        const ok = await persistCaseAssociationFromCombo()
        if (!ok) {
          selectedCaseId = prevCaseId
          display.value = prevDisplay
          originalDisplayValue = prevDisplay
          if (prevCaseId === null) {
            deleteButton.style.display = 'none'
          }
        }
      })

      opts.appendChild(item)
    })
  }

  display.addEventListener('click', (e) => {
    if (!luxDocumentCaseComboEditMode) return
    e.stopPropagation()
    drop.style.display = drop.style.display === 'none' ? 'block' : 'none'
    if (drop.style.display === 'block') {
      display.value = ''
      deleteButton.style.display = 'none'
    }
    display.select()
  })

  display.addEventListener('input', (e) => {
    if (!luxDocumentCaseComboEditMode) return
    renderOptions(e.target.value)
  })

  document.addEventListener('click', (e) => {
    if (!luxDocumentCaseComboEditMode) return
    if (!content.contains(e.target)) {
      drop.style.display = 'none'
      if (selectedCaseId !== null) {
        deleteButton.style.display = 'block'
      }

      const currentValue = display.value.trim()
      const matchesCase = LIST.some((case_) => {
        const title = `${case_.companyCode}-${case_.companyCaseId} ${case_.title}`
        return title === currentValue
      })

      if (!matchesCase) {
        display.value = originalDisplayValue
        renderOptions('')
      }
    }
  })

  root.appendChild(display)
  root.appendChild(deleteButton)
  root.appendChild(drop)

  content.appendChild(root)
  content.appendChild(sharedRow)
  wrapper.appendChild(label)
  wrapper.appendChild(content)

  section.appendChild(wrapper)

  generalBlock.addEventListener('click', () => {
    setTimeout(() => {
      if (generalBlock.querySelector('#luxDocumentCaseComboBox')) return
      section = document.querySelector(
        '#GeneralDocumentData .section-content > .ant-row'
      )
      if (section) {
        section.appendChild(wrapper)
      }
    }, 0)
  })

  document
    .querySelector('.DocumentEditor.page .PageHeader .right-side button:last-child')
    ?.addEventListener('click', onDocumentEditorEditClick)

  listenToButtonClick('Bearbeiten', onDocumentEditorEditClick)
  listenToButtonClick('Edit', onDocumentEditorEditClick)

  // Impower's label casing varies ("Speichern und Weiter", "Als Entwurf Speichern"),
  // so match normalised text instead of listenToButtonClick's exact label.
  document.addEventListener(
    'click',
    (e) => {
      const button = e.target?.closest?.('button')
      if (!button) return
      const text = (button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
      if (DOCUMENT_HEADER_SAVE_LABELS.includes(text)) {
        void syncLinkedDocumentTitleFromEditor()
      }
    },
    true
  )

  setDocumentCaseComboReadOnly(true)
  initCaseList()
}

if (typeof window !== 'undefined') {
  window.parseDocumentHrIdFromLocation = parseDocumentHrIdFromLocation
  window.ensureDocumentEditorComboSpinKeyframes = ensureDocumentEditorComboSpinKeyframes
}
